import classNames from "classnames";
import React, { ElementType, MutableRefObject, useRef } from "react";
import { AriaButtonProps, useButton } from "react-aria";
import styles from "./Button.module.scss";

interface ButtonInterface extends AriaButtonProps<ElementType<any>> {
  element?: React.ElementType<any>;
  className?: string;
  variant?: string;
  icon?: any;
  spanClassName?: string;
  onClick?: () => void;
}

const Button = ({
  element = "button",
  className,
  spanClassName,
  onClick,
  variant = "default",
  icon,
  children,
  ...props
}: ButtonInterface) => {
  // Define the polymorphic component.
  const Element = element;

  return (
    <Element
      onClick={onClick}
      className={classNames({
        [styles["root"]]: true,
        [styles["has-icon"]]: icon,
        [styles[`is-variant-${variant}`]]: true,
        [className ? className : ""]: className,
      })}
    >
      <span className={classNames(spanClassName)}>{children}</span>
      {icon}
    </Element>
  );
};

export default Button;
